import {
  html
} from 'lit';

export default html`
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m11 0h-6c-2.761 0-5 2.239-5 5v6c0 2.761 2.239 5 5 5h6c2.761 0 5-2.239 5-5v-6c0-2.761-2.239-5-5-5zm3.5 11c0 1.93-1.57 3.5-3.5 3.5h-6c-1.93 0-3.5-1.57-3.5-3.5v-6c0-1.93 1.57-3.5 3.5-3.5h6c1.93 0 3.5 1.57 3.5 3.5zm-6.5-7c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zm0 6.5c-1.378 0-2.5-1.122-2.5-2.5 0-1.379 1.122-2.5 2.5-2.5s2.5 1.121 2.5 2.5c0 1.378-1.122 2.5-2.5 2.5zm4.3-6.267c.2943678 0 .533-.23863223.533-.533s-.2386322-.533-.533-.533-.533.23863223-.533.533.2386322.533.533.533z"/></svg>
`;
